// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"Schools_sectionHeader__3a5OQ","formSearch":"Schools_formSearch__3dqv-","formSearchBtn":"Schools_formSearchBtn__3Bqjd"};